import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function Empty({ isMobile = false, style = {} }) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    return (
        <div className={css.empty}>
            {!isMobile && <p className="emptyText">{t('search.no_result_currently')}</p>}
            <div className="emptyImg" style={style}>
                <Image
                    src="https://websiteoss.ecoflow.com/upload/image/1766135755044/empty.svg"
                    layout="fill"
                    className="fullImgs"
                    preview={'false'}
                    alt={t('search.empty_result')}
                />
            </div>
            {isMobile && <p className="emptyText">{t('search.no_result_currently')}</p>}
        </div>
    );
}
